// Angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// CC-Common imports
import { IconConstants } from 'cc-common';

// Component imports
import { CommunityOwnerAlertsEditorComponent } from '../community-owner-alerts-editor/community-owner-alerts-editor.component';

// Service imports
import { ContextManagerService } from '../../../_services/data-services/context-manager.service';

// Model imports
import { AlertResultDto } from '../../_models/alert-result-dto';
import { CommunityAlertResultDto } from '../../_models/community-alert-result-dto';
import { OwnerAlertResultDto } from '../../_models/owner-alert-result-dto';
import { PropertyCommunityInfoResultDto } from '../../../_models/property-community-info-result-dto';

@Component({
    selector: 'app-community-owner-alerts-list',
    templateUrl: './community-owner-alerts-list.component.html',
    styleUrls: ['./community-owner-alerts-list.component.scss']
})
export class CommunityOwnerAlertsListComponent implements OnInit {
    @ViewChild('alertsEditor', { static: false }) alertsEditor: CommunityOwnerAlertsEditorComponent;

    @Input() isOwnerContext = false;
    @Input() allowAdd: boolean;
    @Output() onSuccess: EventEmitter<boolean> = new EventEmitter();

    viewModes: any[];
    viewData: CommunityAlertResultDto | OwnerAlertResultDto;
    alertsData: AlertResultDto[];
    displayedAlerts: AlertResultDto[];
    selectedViewIndex = 1;

    iconEdit = IconConstants.EDIT;
    selectedContext: PropertyCommunityInfoResultDto;

    constructor(private readonly contextService: ContextManagerService) {}

    ngOnInit(): void {
        this.viewModes = [
            { id: 'historical-alerts', text: 'Historical', hint: 'Historical Alerts' },
            { id: 'current-alerts', text: 'Current', hint: 'Current Alerts' },
            { id: 'upcoming-alerts', text: 'Upcoming', hint: 'Upcoming Alerts' }
        ];
        this.displayedAlerts = [];
        this.selectedContext = this.contextService.getSelectedContext();
        this.contextService.getContext().subscribe(() => {
            this.selectedContext = this.contextService.getSelectedContext();
        });
    }

    addNew(): void {
        this.alertsEditor.show(this.isOwnerContext);
    }

    loadAlerts(result: CommunityAlertResultDto | OwnerAlertResultDto): void {
        this.viewData = result;
        this.selectedViewIndex = 1;
        this.alertsData = result.alerts;
        this.displayedAlerts = this.alertsData.filter((r) => r.isCurrent);
        this.sortDisplayAlerts();
    }

    reset(): void {
        this.selectedViewIndex = 1;
        this.alertsData = null;
        this.displayedAlerts = [];
    }

    onTabItemClick(e): void {
        const selectedTab = this.viewModes[e.itemIndex];
        switch (selectedTab.id) {
            case 'historical-alerts':
                this.displayedAlerts = this.alertsData.filter((r) => r.isPast);
                break;
            case 'current-alerts':
                this.displayedAlerts = this.alertsData.filter((r) => r.isCurrent);
                break;
            case 'upcoming-alerts':
                this.displayedAlerts = this.alertsData.filter((r) => r.isFuture);
                break;
        }
        this.sortDisplayAlerts();
    }

    onEditClick(rec: AlertResultDto): void {
        this.alertsEditor.show(this.isOwnerContext, rec);
    }

    onAlertSave(flag: boolean): void {
        this.onSuccess.emit(flag);
    }

    private sortDisplayAlerts(): void {
        this.displayedAlerts.sort((a, b) => {
            if (a.priority === b.priority) {
                return a.effectiveDate < b.effectiveDate ? 1 : -1;
            }
            return a.priority > b.priority ? 1 : -1;
        });
    }
}
